import { createSlice } from '@reduxjs/toolkit'

interface DeliveryState {
  deliveries: any[]
  loading: boolean
  error: string | null
}

const initialState: DeliveryState = {
  deliveries: [],
  loading: false,
  error: null,
}

const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
})

export const { clearError } = deliverySlice.actions
export default deliverySlice.reducer